import { render, staticRenderFns } from "./TFperson.vue?vue&type=template&id=19a78f48"
import script from "./TFperson.vue?vue&type=script&route=%2Fbusiness%2Faccount%2Fmanagement&lang=js"
export * from "./TFperson.vue?vue&type=script&route=%2Fbusiness%2Faccount%2Fmanagement&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports